import React, { Component } from "react";
import ReactTableComponent from "../tables/ReactTable";
import SearchIcon from "../assets/search.png";
import NextArrow from "../assets/next-arrow.png";
import { getContactImageUrl } from "../../config";
import { getContactImageUrl2 } from "../../config";

import { TextField, MenuItem, Drawer, Button } from "@material-ui/core";
import { LeadsInfo, LeadsExport } from "../../Queries";
import {
  contacts,
  allcampaigns,
  Company,
  CustomerInfo,
  ProfileName,
  ManagerName,
  ManagersName
} from "../Leads/LeadsQuery";
import { connect } from "react-redux";
import "./Leads.css";
import Photo from "../assets/photo.png";
import { fetchMethod } from "../../FetchMethod";
//import clearFilters from "../assets/clear-filters.png";
import LeadDetails from "./LeadDetails";
//import SimpleMenu from "./LeadMenu";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExportTo from "./ExportToExcel";

class Leads extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      loading: false,
      allLeads: [],
      action: [],
      totalCount: 0,
      limit: 50,
      offset: 50,
      header: "Leads Management",
      searchFlag: false,
      clickToSearch: false,
      anchorEl: null,
      anchorE2: null,
      fileName: "Leads",
      CustomerData: [],
      Row: [],
      getData: [],
      getCampaign: [],
      getCustomer: [],
      campaignId: undefined,
      openDetails: false,
      drawerOpenClose: false,
      managerId: undefined,
      flag: false,
      flag1: false,
      customer: [],
      campaignlist: [],
      company: "Select",
      camp: "Select",
      value: "Select",
      customerId: "",
      camp1: "Select",
      campaignstatus: "PAUSE",
      status: [],
      profilelist: [],
      profileid: "Select",
      profilename: "Select",
      campaignProfilelist: [],
      campaignNames: [],
      filterColumn: "",
      shortfilter: false,
      LeadsExportData: [],
       Check: "No",

      //campaignStatusList: ["ALL", "LIVE", "PAUSED", "COMPLETED"],
      get campaignStatusList() {
        return this._campaignStatusList;
      },
      set campaignStatusList(value) {
        this._campaignStatusList = value;
      }
    };
  }

  componentDidMount() {
    localStorage.setItem("path", "/leads");
    //this.ExportData();
    this.leadsCustomer();
    this.leadsCampaignsId();
    
    this.props.onHandleCampaign();
    this.props.onHandleSidebarText("/leads");
    // this.props.onHandleSidebarText(this.state.header);
    // this.ExportData();
    // this.state.CustomerData.sort(compare);
  }

  ExportData = () => {
  
    const filter = this.filter();

    fetchMethod(LeadsExport, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          LeadsExportData: res.data.allContacts.Contacts
        });
      });
  };
  leadsCustomer = () => {
    const filter =
      localStorage.getItem("role") === "CUSTOMER"
        ? {
            where: {
              // active: 1,
              customerid: localStorage.getItem("customer")
            }
          }
        : localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              // active: 1,
              createdby: localStorage.getItem("id")
            }
          }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? {
            where: {
              // active: 1,
              campaignmanagerid: localStorage.getItem("id")
            }
          }
        : {
            where: {
              // active: 1
            }
          };

    fetchMethod(CustomerInfo, filter)
      .then(response => {
        return response.json();
      })
      .then(res => {
        res !== undefined
          ? this.setState(
              {
                customer: res.data.allCampaigns.Campaigns.map(id => {
                  return id.customerIbfk1rel.Customers !== undefined
                    ? id.customerIbfk1rel.Customers.length > 0
                      ? id.customerIbfk1rel.Customers[0]
                      : ""
                    : "";
                })
              },
              () => this.LeadCompany()
            )
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };
  LeadCompany = () => {
    const filter = {
      where: {
        and: [
          {
            or: this.state.customer.map(id => {
              return { id: id.id };
            })
          }
        ],
        order: "company asc"
      }
    };

    fetchMethod(Company, filter)
      .then(res => {
        return res.json();
      })
      .then(res => {
        res.data.allCustomers !== undefined && res.data.allCustomers !== null
          ? this.setState({ CustomerData: res.data.allCustomers.Customers })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  leadsCampaignsId = () => {
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              campaignadminid: localStorage.getItem("id"),
              active: 1
            }
          }
        : localStorage.getItem("role") === "SADMIN"
        ? {
            where: {
              active: 1
            }
          }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? {
            where: {
              campaignmanagerid: localStorage.getItem("id"),
              active: 1
            }
          }
        : {
            where: {
              customerid: localStorage.getItem("customer"),
              active: 1
            }
          };
    fetchMethod(allcampaigns, filter)
      .then(response => {
        return response.json();
      })
      .then(res => {
        
        res !== undefined
          ? this.setState(
              {
                Check: "Yes",
                campaignId: res.data.allCampaigns.Campaigns
              },
              () => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              }
            )
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  setListData = response => {
    this.setState({
      allLeads: response.data.allContacts.Contacts,
      action: response.data.allContacts.Contacts,
      totalCount: response.data.allContacts.totalCount
    });
  };
  SetLimit = limit => {
    this.setState({
      limit
    });
  };
  SetOffset = offset => {
    this.setState({ offset });
  };
  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = event => {
    this.setState({ anchorEl: null });
    event.stopPropagation();
  };

  clearFilters = () => {
    this.setState(
      {
        company: "Select",
        camp1: "Select",
        camp: "Select",
        campaignlist: [],
        search: "",
        campaignstatus: "PAUSE",
        searchFlag: false,
        clickToSearch: false,
        profileid: "Select",
        profilename: "Select",
        profilelist: [],
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      }
    );
  };

  setContactRowClick = rowInfo => {};
  debounceTimer = null;
  onSearchClick = searchFlag => {
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.ExportData();
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      },
      200
    );
    searchFlag || this.state.searchFlag
      ? this.setState({ clickToSearch: true }, () => {
          this.ExportData();
        })
      : this.setState({ clickToSearch: false }, () => {
          this.ExportData();
          this.child.current.searchFetch(this.state.limit, this.state.offset);
        });
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  toggleDrawer = (side, open, row) => event => {
    fetchMethod(contacts(row))
      .then(res => {
        return res.json();
      })
      .then(res => {
        this.setState({
          drawerOpenClose: false,
          getData: res.data.allContacts.Contacts[0],
          getCampaign: res.data.allContacts.Contacts[0].Campaigns.Campaigns,
          getCustomer:
            res.data.allContacts.Contacts[0].Campaigns.Campaigns[0].Customers
              .Customers[0],
          status: res.data.allContacts.Contacts[0].contactstatus
        });
      })
      .catch(e => {
        this.setState({ loading: true });
      });

    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };

  closeDetails() {
    this.setState({ openDetails: false, getData: [], getCampaign: [] });
  }

  handleCompany = (event, v) => {
    if (v !== undefined && v !== null) {
      this.setState({
        profileid: "Select",
        profilename: "Select",
        camp1: "Select",
        camp: "Select"
      });
      const filter =
        localStorage.getItem("role") === "CAMPAIGNMANAGER"
          ? {
              where: {
                active: 1,
                customerid: v.id,
                campaignmanagerid: localStorage.getItem("id"),
                order: "name asc"
              }
            }
          : {
              where: {
                active: 1,
                customerid: v.id,
                order: "name asc"
              }
            };

      const test = {
        where: {
          id: v.id,
          contactstatus: {
            nlike: "%noop%",
            options: "i"
          }
        }
      };

      fetchMethod(ManagerName, filter)
        .then(res => res.json())
        .then(res => {
          res !== undefined &&
          res !== null &&
          res.data.allCampaigns !== undefined &&
          res.data.allCampaigns !== null
            ? this.setState(
                {
                  company: "",
                  campaignlist: "",
                  customerId: ""
                },
                () => {
                  this.setState(
                    {
                      company: v.company,
                      campaignlist: res.data.allCampaigns.Campaigns,
                      customerId: v.id
                    },
                    () => {
                      this.onSearchClick();
                    }
                  );
                }
              )
            : this.setState({ loading: true });
        })
        .catch(e => console.log(e));
      fetchMethod(ProfileName, test)
        .then(res => res.json())
        .then(res => {
          res !== undefined &&
          res !== null &&
          res.data.allCustomers !== undefined &&
          res.data.allCustomers !== null &&
          res.data.allCustomers.Customers[0] !== null &&
          res.data.allCustomers.Customers[0] !== undefined
            ? this.setState(
                {
                  company: "",

                  profilelist: "",
                  customerId: ""
                },
                () => {
                  this.setState(
                    {
                      company: v.company,
                      profilelist:
                        res.data.allCustomers.Customers[0]
                          .Customerlinkedinprofilesfk !== undefined
                          ? res.data.allCustomers.Customers[0]
                              .Customerlinkedinprofilesfk
                              .Customerlinkedinprofiles
                          : "",

                      customerId: v.id
                    },
                    () => {}
                  );
                }
              )
            : this.setState({ loading: true });
        })
        .catch(e => console.log(e));
    } else {
      this.setState({
        company: "Select",
        camp1: "Select",
        loading: true
      });
    }
  };
  handleProfile = (event, v) => {
    if (v === null) {
      this.setState({
        profilename: "Select",
        profilelist: this.state.profilelist
      });
      return;
    }

    if (
      v !== undefined &&
      v !== null &&
      this.state.company !== "Select" &&
      this.state.company
    ) {
      this.setState({
        camp1: "Select",
        camp: "Select",
        profileid: v.id,
        profilename: v.name
      });

      const test = {
        where: {
          linkedinid: v.id,
          order: "name asc"
        }
      };

      fetchMethod(ManagersName, test)
        .then(res => res.json())
        .then(res => {
          res !== undefined &&
          res !== null &&
          res.data.allCampaigns !== undefined &&
          res.data.allCampaigns !== null &&
          res.data.allCampaigns.Campaigns !== null &&
          res.data.allCampaigns.Campaigns !== undefined
            ? this.setState(
                {
                  profileid: "",
                  campaignProfilelist: "",
                  // profilelist: "",
                  profilename: ""
                },
                () => {
                  this.setState(
                    {
                      profilename: v.name,
                      campaignNames:
                        res.data.allCampaigns.Campaigns !== undefined
                          ? res.data.allCampaigns.Campaigns
                          : "",
                      campaignProfilelist:
                        res.data.allCampaigns.Campaigns !== undefined
                          ? res.data.allCampaigns.Campaigns
                          : [],

                      profileid: v.id
                    },
                    () => {
                      this.onSearchClick();
                    }
                  );
                }
              )
            : this.setState({ loading: true });
        });
    } else {
      this.setState({
        camp: "Select",
        camp1: "Select",
        loading: true,
        campaignProfilelist: "Select"
      });
    }
  };

  handleCampaign = (event, v) => {
    if (
      v !== undefined &&
      v !== null &&
      this.state.company !== "Select" &&
      this.state.company
    )
      this.setState(
        {
          camp: "",
          camp1: "",
          searchFlag: ""
        },
        () => {
          this.setState(
            {
              camp: v.id,
              camp1: v.name,
              searchFlag: true
            },
            () => {
              this.child.current.searchFetch(
                this.state.limit,
                this.state.offset
              );
              this.onSearchClick();
            }
          );
        }
      );
    else {
      this.setState({ campaignlist: this.state.campaignlist });
    }
  };
  handleChange = event => {
    this.setState({ search: event.target.value }, () => {
      if (this.state.search !== "") {
        this.setState(
          {
            searchFlag: true
          },
          () => {
            this.onSearchClick();
          }
        );
      } else {
        this.setState(
          {
            searchFlag: false
          },
          () => {
            this.onSearchClick();
          }
        );
      }
    });
  };
  onStatusChange = event => {
    this.setState(
      {
        campaignstatus: event.target.value,
        searchFlag: true
      },
      () => {
        this.onSearchClick();
      }
    );
  };

  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  NameFilter = () => {
    this.setState({ filterColumn: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  NameFilter1 = () => {
    this.setState({ filterColumn: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ filterColumn: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter1 = () => {
    this.setState(
      { filterColumn: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ filterColumn: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter1 = () => {
    this.setState(
      { filterColumn: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ filterColumn: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter1 = () => {
    this.setState({ filterColumn: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LeadStatusFilter = () => {
    this.setState(
      { filterColumn: "contactstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LeadStatusFilter1 = () => {
    this.setState(
      { filterColumn: "contactstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  filter = () => {
    const search = this.state.clickToSearch ? this.state.search : "";

    const like = `%${search}%`;
    const filter =
      localStorage.getItem("role") === "CUSTOMER"
        ? this.state.campaignstatus === "ALL"
          ? this.state.company === "Select"
            ? {
                where: {
                  active: "1 ",
                  order: this.state.filterColumn,
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : this.state.company !== "Select" &&
              this.state.profilename === "Select"
            ? {
                where: {
                  active: "1 ",
                  order: this.state.filterColumn,
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignlist !== undefined &&
                        this.state.campaignlist.length > 0
                          ? this.state.campaignlist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.profilename !== "Select" &&
              this.state.camp === "Select"
            ? {
                where: {
                  active: "1 ",
                  order: this.state.filterColumn,
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignProfilelist !== undefined &&
                        this.state.campaignProfilelist.length > 0
                          ? this.state.campaignProfilelist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.camp
            ? {
                where: {
                  active: "1 ",
                  order: this.state.filterColumn,
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  campaignid: this.state.camp,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : {
                where: {
                  active: "1 ",
                  order: this.state.filterColumn,
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
          : this.state.company === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : this.state.company !== "Select" &&
            this.state.profilename === "Select"
          ? {
              where: {
                active: "1 ",
                order: this.state.filterColumn,
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignlist !== undefined &&
                      this.state.campaignlist.length > 0
                        ? this.state.campaignlist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.profilename !== "Select" && this.state.camp === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignProfilelist !== undefined &&
                      this.state.campaignProfilelist.length > 0
                        ? this.state.campaignProfilelist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.camp
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                campaignid: this.state.camp,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? this.state.campaignstatus === "ALL"
          ? this.state.company === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : this.state.company !== "Select" &&
              this.state.profilename === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignlist !== undefined &&
                        this.state.campaignlist.length > 0
                          ? this.state.campaignlist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.profilename !== "Select" &&
              this.state.camp === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignProfilelist !== undefined &&
                        this.state.campaignProfilelist.length > 0
                          ? this.state.campaignProfilelist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.camp
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  campaignid: this.state.camp,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
          : this.state.company === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : this.state.company !== "Select" &&
            this.state.profilename === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignlist !== undefined &&
                      this.state.campaignlist.length > 0
                        ? this.state.campaignlist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.profilename !== "Select" && this.state.camp === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignProfilelist !== undefined &&
                      this.state.campaignProfilelist.length > 0
                        ? this.state.campaignProfilelist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.camp
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                campaignid: this.state.camp,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "ADMIN"
        ? this.state.campaignstatus === "ALL"
          ? this.state.company === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : this.state.company !== "Select" &&
              this.state.profilename === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignlist !== undefined &&
                        this.state.campaignlist.length > 0
                          ? this.state.campaignlist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.profilename !== "Select" &&
              this.state.camp === "Select"
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    },
                    {
                      or:
                        this.state.campaignProfilelist !== undefined &&
                        this.state.campaignProfilelist.length > 0
                          ? this.state.campaignProfilelist.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    }
                  ]
                }
              }
            : this.state.camp
            ? {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  campaignid: this.state.camp,
                  and: [
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
            : {
                where: {
                  active: "1 ",
                  contactstatus: {
                    nlike: "%noop%",
                    options: "i"
                  },
                  order: this.state.filterColumn,
                  and: [
                    {
                      or:
                        this.state.campaignId !== undefined &&
                        this.state.campaignId !== null &&
                        this.state.campaignId.length > 0
                          ? this.state.campaignId.map(id => {
                              return { campaignid: id.id };
                            })
                          : [{ campaignid: "" }]
                    },
                    {
                      or: [
                        { name: { like: like, options: "i" } },
                        { location: { like: like, options: "i" } },
                        { designation: { like: like, options: "i" } },
                        { organization: { like: like, options: "i" } }
                      ]
                    }
                  ]
                }
              }
          : this.state.company === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : this.state.company !== "Select" &&
            this.state.profilename === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignlist !== undefined &&
                      this.state.campaignlist.length > 0
                        ? this.state.campaignlist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.profilename !== "Select" && this.state.camp === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignProfilelist !== undefined &&
                      this.state.campaignProfilelist.length > 0
                        ? this.state.campaignProfilelist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.camp
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                campaignid: this.state.camp,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignstatus: this.state.campaignstatus,
                and: [
                  {
                    or:
                      this.state.campaignId !== undefined &&
                      this.state.campaignId !== null &&
                      this.state.campaignId.length > 0
                        ? this.state.campaignId.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  },
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
        : this.state.campaignstatus === "ALL"
        ? this.state.company === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : this.state.company !== "Select" &&
            this.state.profilename === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignlist !== undefined &&
                      this.state.campaignlist.length > 0
                        ? this.state.campaignlist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.profilename !== "Select" && this.state.camp === "Select"
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  },
                  {
                    or:
                      this.state.campaignProfilelist !== undefined &&
                      this.state.campaignProfilelist.length > 0
                        ? this.state.campaignProfilelist.map(id => {
                            return { campaignid: id.id };
                          })
                        : [{ campaignid: "" }]
                  }
                ]
              }
            }
          : this.state.camp
          ? {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                campaignid: this.state.camp,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
          : {
              where: {
                active: "1 ",
                contactstatus: {
                  nlike: "%noop%",
                  options: "i"
                },
                order: this.state.filterColumn,
                and: [
                  {
                    or: [
                      { name: { like: like, options: "i" } },
                      { location: { like: like, options: "i" } },
                      { designation: { like: like, options: "i" } },
                      { organization: { like: like, options: "i" } }
                    ]
                  }
                ]
              }
            }
        : this.state.company === "Select"
        ? {
            where: {
              active: "1 ",
              contactstatus: {
                nlike: "%noop%",
                options: "i"
              },
              order: this.state.filterColumn,
              campaignstatus: this.state.campaignstatus,
              and: [
                {
                  or: [
                    { name: { like: like, options: "i" } },
                    { location: { like: like, options: "i" } },
                    { designation: { like: like, options: "i" } },
                    { organization: { like: like, options: "i" } }
                  ]
                }
              ]
            }
          }
        : this.state.company !== "Select" && this.state.profilename === "Select"
        ? {
            where: {
              active: "1 ",
              contactstatus: {
                nlike: "%noop%",
                options: "i"
              },
              order: this.state.filterColumn,
              campaignstatus: this.state.campaignstatus,
              and: [
                {
                  or: [
                    { name: { like: like, options: "i" } },
                    { location: { like: like, options: "i" } },
                    { designation: { like: like, options: "i" } },
                    { organization: { like: like, options: "i" } }
                  ]
                },
                {
                  or:
                    this.state.campaignlist !== undefined &&
                    this.state.campaignlist.length > 0
                      ? this.state.campaignlist.map(id => {
                          return { campaignid: id.id };
                        })
                      : [{ campaignid: "" }]
                }
              ]
            }
          }
        : this.state.profilename !== "Select" && this.state.camp === "Select"
        ? {
            where: {
              active: "1 ",
              contactstatus: {
                nlike: "%noop%",
                options: "i"
              },
              order: this.state.filterColumn,
              campaignstatus: this.state.campaignstatus,
              and: [
                {
                  or: [
                    { name: { like: like, options: "i" } },
                    { location: { like: like, options: "i" } },
                    { designation: { like: like, options: "i" } },
                    { organization: { like: like, options: "i" } }
                  ]
                },
                {
                  or:
                    this.state.campaignProfilelist !== undefined &&
                    this.state.campaignProfilelist.length > 0
                      ? this.state.campaignProfilelist.map(id => {
                          return { campaignid: id.id };
                        })
                      : [{ campaignid: "" }]
                }
              ]
            }
          }
        : this.state.camp
        ? {
            where: {
              active: "1 ",
              contactstatus: {
                nlike: "%noop%",
                options: "i"
              },
              order: this.state.filterColumn,
              campaignstatus: this.state.campaignstatus,
              campaignid: this.state.camp,
              and: [
                {
                  or: [
                    { name: { like: like, options: "i" } },
                    { location: { like: like, options: "i" } },
                    { designation: { like: like, options: "i" } },
                    { organization: { like: like, options: "i" } }
                  ]
                }
              ]
            }
          }
        : {
            where: {
              active: "1 ",
              contactstatus: {
                nlike: "%noop%",
                options: "i"
              },
              order: this.state.filterColumn,
              campaignstatus: this.state.campaignstatus,
              and: [
                {
                  or: [
                    { name: { like: like, options: "i" } },
                    { location: { like: like, options: "i" } },
                    { designation: { like: like, options: "i" } },
                    { organization: { like: like, options: "i" } }
                  ]
                }
              ]
            }
          };

    return filter;
  };

  render() {

    const Check = this.state.Check;
     const filterr = this.filter();
    const allLeads = [...this.state.allLeads];
    const LeadsExportData = [...this.state.allLeads];
    //  const LeadsExportData = [...this.state.LeadsExportData];
    allLeads.map(lead => {
      if (lead.profileimage !== null && lead.profileimage !== undefined) {
        let str = lead.profileimage.substr(0, 5);
        if (str === "https") {
          lead.Image = (
            <div
              style={{ cursor: "pointer" }}
              onClick={this.toggleDrawer("openDetails", true, lead.id)}
            >
              <img
                src={lead.profileimage}
                onError={({ currentTarget }) => {
                   let imageSourceUrl = getContactImageUrl;
                  if (lead.id > 917500) {
                    imageSourceUrl = getContactImageUrl2;
                  }
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = imageSourceUrl.url + lead.image;
                }}
                // src={lead.profileimage}
                style={{ borderRadius: "50%", width: "30px" }}
              />
            </div>
          );
        } else if (str !== "https") {
          lead.Image = (
            <div
              style={{ cursor: "pointer" }}
              onClick={this.toggleDrawer("openDetails", true, lead.id)}
            >
              <img src={Photo} style={{ borderRadius: "50%", width: "30px" }} />
            </div>
          );
        }
      } else {
        lead.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.toggleDrawer("openDetails", true, lead.id)}
          >
            <img src={Photo} style={{ borderRadius: "50%", width: "30px" }} />
          </div>
        );
      }

      lead.Name = (
        <div
          style={{ cursor: "pointer" }}
          onClick={this.toggleDrawer("openDetails", true, lead.id)}
        >
          {lead.name}
        </div>
      );

      lead.Profile =
        lead.Campaigns.Campaigns[0].Profile.Customerlinkedinprofiles[0].name;

      lead.Customer = (
        <div
          style={{ cursor: "pointer" }}
          onClick={this.toggleDrawer("openDetails", true, lead.id)}
        >
          {
            (lead.Customer =
              lead.Campaigns &&
              lead.Campaigns.Campaigns &&
              lead.Campaigns.Campaigns[0] !== undefined &&
              lead.Campaigns.Campaigns[0].Customers &&
              lead.Campaigns.Campaigns[0].Customers.Customers &&
              lead.Campaigns.Campaigns[0].Customers.Customers[0] &&
              lead.Campaigns.Campaigns[0].Customers.Customers[0].company &&
              lead.Campaigns.Campaigns[0].Customers.Customers[0].company !==
                undefined
                ? lead.Campaigns.Campaigns[0].Customers.Customers[0].company
                : "")

            // lead.Campaigns.Campaigns[0] !== undefined
            //   ? lead.Campaigns.Campaigns[0].Customers.Customers[0].company
            //   : ""
          }
        </div>
      );

      lead.Campaign =
        lead.Campaigns.Campaigns[0] !== undefined
          ? lead.Campaigns.Campaigns[0].name
          : "";
      lead.Campaign_Status =
        lead.campaignstatus !== undefined && lead.campaignstatus !== null
          ? lead.campaignstatus
          : "";
      lead.Organization =
        lead.organization !== undefined && lead.organization !== null
          ? lead.organization
          : "";
      lead.Designation =
        lead.designation !== undefined && lead.designation !== null
          ? lead.designation
          : "";
      lead.Location =
        lead.location !== undefined && lead.location !== null
          ? lead.location
          : "";
      lead.Status =
        lead.contactstatus === "PROSPECT"
          ? "Prospect"
          : lead.contactstatus === "OPPORTUNITY"
          ? "Opportunity"
          : "Suspect";
      let arr = lead.Contactmessagesfk.Contactmessages;
      let action = lead.Contactlogs.Contactlogs;

      if (arr !== null && arr !== undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type === "RECEIVED") {
            //  let date = new Date(arr[i].createdon);
            let Received_time = this.formatDate(arr[i].createdon);
            lead.Received_Msg = Received_time;
          }
          if (arr[i].type === "SENT") {
            // let date = new Date(arr[i].createdon);

            let Send_time = this.formatDate(arr[i].createdon);
            lead.Send_Msg = Send_time;
          }
        }
      }

      if (action !== null && action !== undefined) {
        for (let i = 0; i < action.length; i++) {
          //  let date = new Date(action[i].createdon);
          if (action[i].action === "CONVERT_TO_OPPORTUNITY") {
            var Opportunity = this.formatDate(action[i].createdon);
            lead.Opportunity = Opportunity;
          }
          if (action[i].action === "CONVERT_TO_PROSPECT") {
            let Prospect = this.formatDate(action[i].createdon);
            lead.Prospect = Prospect;
          }
          if (action[i].action === "CONVERT_TO_SUSPECT") {
            let Suspect = this.formatDate(action[i].createdon);
            lead.Suspect = Suspect;
          }
        }
      }
      return null;
    });
    
    const thLeadsArray = [
      {
        Header: "Image",
        accessor: "Image"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "Name"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Current Company
            </div>
          );
        },
        accessor: "Organization"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Current Position
            </div>
          );
        },
        accessor: "Designation"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Locations
            </div>
          );
        },
        accessor: "Location"
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LeadStatusFilter
                  : this.LeadStatusFilter1
              }
            >
              Lead Status
            </div>
          );
        },
        accessor: "Status"
      },
      {
        Header: "Last Message Sent",
        accessor: "Send_Msg"
      },
      {
        Header: "Last Message Received",
        accessor: "Received_Msg"
      },
      {
        Header: "Customer",
        accessor: "Customer"
      },
      {
        Header: "Profile",
        accessor: "Profile"
      },
      {
        Header: "Campaign Name",
        accessor: "Campaign"
      },
      {
        Header: "Contact Status",
        accessor: "Campaign_Status"
      }
    ];

    LeadsExportData.map(lead => {
      lead.Profile =
        lead.Campaigns.Campaigns[0].Profile.Customerlinkedinprofiles[0].name;

      lead.Customer =
        lead.Campaigns &&
        lead.Campaigns.Campaigns &&
        lead.Campaigns.Campaigns[0] !== undefined &&
        lead.Campaigns.Campaigns[0].Customers &&
        lead.Campaigns.Campaigns[0].Customers.Customers &&
        lead.Campaigns.Campaigns[0].Customers.Customers[0] &&
        lead.Campaigns.Campaigns[0].Customers.Customers[0].company &&
        lead.Campaigns.Campaigns[0].Customers.Customers[0].company !== undefined
          ? lead.Campaigns.Campaigns[0].Customers.Customers[0].company
          : "";

      // lead.Customer =
      //   lead.Campaigns.Campaigns[0] !== undefined
      //     ? lead.Campaigns.Campaigns[0].Customers.Customers[0].company
      //     : "";
      lead.Campaign =
        lead.Campaigns.Campaigns[0] !== undefined
          ? lead.Campaigns.Campaigns[0].name
          : "";

      lead.Status =
        lead.contactstatus === "PROSPECT"
          ? "Prospect"
          : lead.contactstatus === "OPPORTUNITY"
          ? "Opportunity"
          : "Suspect";
      let arr = lead.Contactmessagesfk.Contactmessages;
      let action = lead.Contactlogs.Contactlogs;

      if (arr !== null && arr !== undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type === "RECEIVED") {
            //  let date = new Date(arr[i].createdon);
            let Received_time = this.formatDate(arr[i].createdon);
            lead.Received_Msg = Received_time;
          }
          if (arr[i].type === "SENT") {
            // let date = new Date(arr[i].createdon);

            let Send_time = this.formatDate(arr[i].createdon);
            lead.Send_Msg = Send_time;
          }
        }
      }

      if (action !== null && action !== undefined) {
        for (let i = 0; i < action.length; i++) {
          //  let date = new Date(action[i].createdon);
          if (action[i].action === "CONVERT_TO_OPPORTUNITY") {
            var Opportunity = this.formatDate(action[i].createdon);
            lead.Opportunity = Opportunity;
          }
          if (action[i].action === "CONVERT_TO_PROSPECT") {
            let Prospect = this.formatDate(action[i].createdon);
            lead.Prospect = Prospect;
          }
          if (action[i].action === "CONVERT_TO_SUSPECT") {
            let Suspect = this.formatDate(action[i].createdon);
            lead.Suspect = Suspect;
          }
        }
      }
    });
    //  const filterr = this.filter();
    // if (Check === "Yes"){
    return (
     
      <div className="Clients">
        <div className="top-flexbox">
          <div className="title-block">
            <h1>Leads</h1>
            <p>
              Total <span>{this.state.totalCount} Records</span>
            </p>
          </div>
        </div>
        <div className="Leads1">
          <Drawer
            anchor="right"
            open={this.state.openDetails}
            onClose={() => this.closeDetails()}
          >
            <LeadDetails
              Close={() => this.closeDetails()}
              details={this.state.getData}
              Campaigns={this.state.getCampaign}
              Customer={this.state.getCustomer}
              Leads={this.state.allLeads}
              Status={this.state.status}
            />
          </Drawer>
          <div className="modalButton-flex">
            <div className="allFiltersField">
              {/* <div className="selectListDiv">
                <Autocomplete
                  id="country-select-demo"
                  blurOnSelect={true}
                  value={this.state.company}
                  onChange={(event, value) => this.handleCompany(event, value)}
                  options={
                    this.state.CustomerData ? this.state.CustomerData : []
                  }
                  // getOptionLabel={option => option.company}
                  renderOption={option => (
                    <MenuItem value={option.id}>{option.company}</MenuItem>
                  )}
                  renderInput={params => (
                    <TextField
                      id="outlined-select-currency"
                      {...params}
                      label="Customer"
                      variant="outlined"
                      value={null}
                      //value={this.state.company}
                      InputProps={{
                        ...params.InputProps,
                        // autoComplete: "Company",

                        endAdornment: (
                          <img
                            src={NextArrow}
                            style={{
                              width: "7px"
                            }}
                          />
                        )
                      }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps
                        //autoComplete: "Company"

                        // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              </div> */}
              {/* div for profile  */}
              {/* <div className="companyDiv">
                <Autocomplete
                  id="country-demo"
                  blurOnSelect={true}
                  value={this.state.profilename}
                  onChange={(event, value) => this.handleProfile(event, value)}
                  options={this.state.profilelist ? this.state.profilelist : []}
                  renderOption={option => (
                    <MenuItem value={option.id}>{option.name}</MenuItem>
                  )}
                  renderInput={params => (
                    <TextField
                      id="outlined-select-currency"
                      {...params}
                      value={null}
                      label="Profile"
                      //   placeholder="Select"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        //autoComplete: "camp",
                        endAdornment: (
                          <img
                            src={NextArrow}
                            style={{
                              width: "7px"
                            }}
                          />
                        )
                      }}
                      fullWidth
                      // value={this.state.camp}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps
                        // autoComplete: "camp"

                        // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              </div> */}

              {/* <div className="companyDiv">
                <Autocomplete
                  id="country-demo"
                  blurOnSelect={true}
                  value={this.state.camp1}
                  onChange={(event, value) => this.handleCampaign(event, value)}
                  options={
                    this.state.company !== "Select" &&
                    this.state.profilename !== "Select" &&
                    this.state.campaignNames
                      ? this.state.campaignNames
                      : []
                  }
                  // getOptionLabel={option => option.name}

                  renderOption={option => (
                    <MenuItem value={option.id}>{option.name}</MenuItem>
                  )}
                  renderInput={params => (
                    <TextField
                      id="outlined-select-currency"
                      {...params}
                      value={null}
                      label="Campaign"
                      //   placeholder="Select"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        autoComplete: "camp",
                        endAdornment: (
                          <img
                            src={NextArrow}
                            style={{
                              width: "7px"
                            }}
                          />
                        )
                      }}
                      fullWidth
                      // value={this.state.camp}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "camp"

                        // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              </div> */}
              {/* <div className="companyDiv">
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Contact Status"
                  placeholder="SELECT"
                  value={this.state.campaignstatus}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.onStatusChange}
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <img src={NextArrow} style={{ width: "7px" }} />
                    )
                  }}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  <MenuItem value="LIVE">LIVE</MenuItem>
                  <MenuItem value="PAUSE">PAUSE</MenuItem>
                  <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                </TextField>
              </div> */}
              <div className="searchDiv">
                <TextField
                  id="outlined-search"
                  label="Search"
                  placeholder="Company/Name/Position/Location"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  value={this.state.search}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange}
                  onKeyDown={this.onSearchKeyDown}
                  InputProps={{
                    endAdornment: (
                      <img
                        src={SearchIcon}
                        style={{ width: "15px", cursor: "pointer" }}
                        onClick={() => this.onSearchClick()}
                      />
                    )
                  }}
                />
              </div>
              <div className="leadClearButton">
                <Button className="button" onClick={this.clearFilters}>
                  R<span style={{ textTransform: "lowercase" }}>eset</span>
                </Button>
              </div>
              <div>
                <ExportTo fileData={LeadsExportData} />
              </div>
            </div>
          </div>
        </div>
       {Check == "Yes" && (
        <ReactTableComponent
          ref={this.child}
          listData={allLeads}
          listConfig={thLeadsArray}
          setData={this.setListData}
          query={LeadsInfo}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filterr}
          onRowClick={this.setContactRowClick}
          clickToSearch={this.state.clickToSearch}
        />
         )}
      </div>

    );
             //   }
  }
}
//------------------
const mapDispatchToProps = dispatch => {
  return {
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),
    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

export default connect(null, mapDispatchToProps)(Leads);
